import React from 'react'

type Props = React.SVGProps<SVGSVGElement>;

export const ExAdminIcon = ({ width = 40, height = 40, ...props }: Props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 300 300"
            {...props}
        >
            <path
                style={{
                    fill: 'orange',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M3.125 149.688c-0.34 39.009 15.686 77.987 43.646 105.091 27.127 28.107 66.237 43.591 105.07 43.528 38.936 0.004 77.542 -15.816 104.749 -43.763C283.837 227.205 300.798 188.52 299.609 149.587c1.161 -38.944 -16.047 -77.237 -43.113 -104.614C228.945 17.498 190.266 0.696 151.078 1.563c-39.026 -0.525 -77.868 16.156 -105.024 43.985C18.589 72.651 2.989 111.087 3.125 149.688ZM64.844 231.25h175.391c-0.686 -12.796 -4.235 -25.259 -9.077 -37.044 -1.386 -3.502 -3.925 -7.873 -5.903 -11.877 -2.063 -3.18 -3.922 -6.44 -6.19 -9.579 -4.263 -5.634 -8.792 -11.061 -14.15 -15.759 -3.92 -3.502 -8.052 -6.649 -12.566 -9.388 -14.282 -9.283 -31.382 -12.228 -48.103 -11.176 -11.26 1.414 -22.202 5.22 -31.776 11.338 -3.504 2.252 -6.98 4.796 -10.153 7.344 -5.568 4.721 -10.664 9.979 -14.92 15.87 -3.18 4.232 -5.966 8.598 -8.537 13.124C70.915 198.604 66.003 214.754 64.844 231.25Zm50 -120.313c1.362 0.277 2.301 2.271 3.178 3.001 1.475 1.579 3.016 3.17 4.588 4.8 0.749 0.595 1.451 1.227 2.356 1.913 0.93 0.644 1.81 1.039 1.987 2.395 2.08 0.057 3.721 1.566 5.527 2.372 0.977 0.503 1.97 0.991 3.026 1.3 0.927 0.296 2.12 0.491 2.385 1.406 6.939 1.125 14.003 3.535 20.998 1.443 3.223 -0.441 6.866 -1.199 9.859 -2.592 3.2 -0.542 6.701 -3.737 9.378 -3.929 0.393 -1.344 1.587 -2.137 2.88 -3.141 1.76 -1.243 3.102 -2.916 4.653 -4.462 0.407 -0.327 0.831 -1.042 1.277 -1.109 0.016 -0.775 0.903 -1.138 1.404 -1.911 0.436 -0.716 0.773 -1.479 1.895 -1.487 0.126 -1.858 1.273 -3.389 2.114 -4.961 0.458 -0.766 0.85 -1.565 1.257 -2.355 0.339 -0.725 0.443 -1.8 1.316 -2.059 0.253 -1.466 0.882 -3.364 1.098 -5.127 0.655 -1.434 0.379 -4.146 1.637 -4.639v-9.375c0.019 -1.126 0.009 -2.276 -0.203 -3.382 -0.848 -0.925 -0.859 -3.413 -1.471 -4.908 -0.328 -2.996 -1.279 -4.884 -2.53 -7.357 -1.021 -2.262 -2.898 -4.702 -3.217 -7.009l-1.563 -0.391c-0.213 -1.386 -1.631 -2.423 -2.341 -3.489 -0.96 -1.151 -2.616 -2.202 -2.737 -3.542 -1.202 -0.274 -2.158 -1.342 -3.013 -2.07 -0.85 -0.795 -2.191 -1.525 -2.456 -2.618 -1.953 -0.048 -3.516 -1.396 -5.187 -2.213 -0.84 -0.409 -1.778 -0.971 -2.58 -1.263 -0.771 -0.29 -1.796 -0.352 -1.998 -1.211 -1.661 -0.275 -3.831 -0.988 -5.848 -1.173 -1.507 -0.758 -4.543 -0.199 -5.09 -1.561 -2.935 0.123 -5.898 -0.158 -8.826 0.107 -0.98 0.276 -1.671 0.881 -2.783 0.844 -3.29 0.504 -7.313 1.234 -9.871 2.565 -3.127 0.679 -6.041 3.641 -8.989 3.905 -0.222 1.093 -1.609 1.791 -2.493 2.645 -0.947 0.813 -1.775 1.751 -2.976 2.043 -0.173 1.545 -1.844 2.314 -2.69 3.488 -0.861 1.246 -2.132 2.123 -2.388 3.544l-1.563 0.391c-0.16 1.809 -1.28 3.305 -2.079 4.868 -0.479 0.761 -0.829 1.593 -1.273 2.368 -0.3 0.852 -0.536 1.889 -1.335 2.139 -0.274 1.517 -0.907 3.5 -1.143 5.328 -0.661 1.395 -0.439 3.929 -1.591 4.438v9.163c-0.099 1.136 0.065 2.253 0.154 3.374 0.923 1.284 1.023 3.496 1.487 4.963 0.299 3.004 1.239 4.901 2.495 7.391 1.031 2.302 3.027 4.775 3.287 7.141Z"
            />
            <path
                style={{
                    fill: '#fff',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M241.016 231.055c-2.3 -15.018 -5.104 -30.312 -12.622 -43.788 -2.256 -4.741 -4.901 -9.14 -7.854 -13.379 -2.671 -4.064 -5.855 -7.651 -9.022 -11.258 -2.981 -2.977 -5.967 -6.05 -9.234 -8.633 -11.526 -9.521 -25.504 -15.757 -40.326 -17.875 -4.232 -0.373 -8.496 -0.055 -12.733 -0.184 -11.637 -0.278 -22.83 3.996 -33.051 9.045 -4.794 2.534 -9.145 5.645 -13.335 8.966 -3.565 3.26 -7.649 6.444 -10.683 10.34 -2.977 3.476 -5.912 6.976 -8.462 10.851 -2.228 3.501 -4.576 6.904 -6.333 10.776 -3.621 7.194 -6.99 14.625 -8.897 22.489 -2.396 7.193 -3.436 14.845 -4.206 22.307 0.436 1.518 3.623 0.61 4.684 0.929 56.364 -0.002 112.717 0.002 169.077 -0.002 1.022 -0.025 2.136 0.025 2.996 -0.584ZM137.5 128.516c5.984 0.804 12.949 2.841 18.508 2.202 4.424 -1.266 8.97 -1.459 12.955 -3.298 3.208 -0.829 5.928 -2.779 8.879 -4.169 0.67 -0.805 1.664 -1.548 2.666 -2.204 1.323 -1.064 2.96 -2.395 4.207 -3.874 0.595 -0.574 1.192 -1.146 1.74 -1.761 0.413 -0.528 1.232 -0.72 1.204 -1.608 3.851 -2.588 4.643 -8.923 7.654 -11.851 0.508 -4.421 2.576 -9.407 2.734 -13.482 0.033 -3.768 0.245 -7.568 -0.831 -11.203 -0.735 -2.424 -1.088 -5.416 -1.84 -7.607 -1.392 -2.972 -3.354 -6.97 -4.952 -9.706 -1.035 -1.274 -2.055 -2.463 -3.31 -4.013 -0.941 -1.293 -2.98 -2.597 -3.129 -3.988 -2.635 -0.918 -4.259 -4.031 -7.46 -5.137 -1.375 -0.732 -2.698 -1.566 -4.106 -2.236 -1.121 -0.893 -3.283 -0.949 -3.668 -2.002 -4.396 -0.594 -8.637 -2.038 -13.021 -2.68 -3.412 -0.37 -6.777 -0.057 -10.047 0.852 -4.684 0.613 -9.104 1.494 -13.061 3.852 -1.945 1.231 -4.43 2.314 -6.209 3.425 -1.774 1.133 -3.661 3.423 -5.319 3.926 -0.163 1.532 -2.208 2.591 -3.166 4.027 -0.879 0.831 -1.419 1.952 -2.352 2.915 -1.343 1.507 -2.061 3.463 -3.116 5.18 -0.496 0.826 -0.904 1.692 -1.359 2.535 -0.3 0.852 -0.536 1.889 -1.335 2.139 -0.532 3.158 -1.444 6.264 -2.111 9.397 -0.879 2.718 -0.575 5.589 -0.623 8.437 -0.296 2.54 0.158 4.956 0.999 7.329 0.552 2.051 0.894 4.537 1.406 6.41 1.123 3.344 3.123 6.176 4.734 9.455 0.592 1.063 1.469 2.065 2.325 3.2 1.366 1.758 2.835 3.139 4.397 4.751 0.936 1.306 2.623 2.409 3.557 3.205 1.858 1.811 4.239 3.269 6.355 4.207 1.146 0.613 2.301 1.2 3.501 1.698 1.136 0.457 2.924 0.639 3.195 1.675Z"
            />
            <path
                style={{
                    fill: '#ffce73',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M148.438 40.625v-0.781h-1.172c-0.091 0.649 0.334 0.846 0.863 0.781H148.438Zm9.375 0v-0.781h-1.172c-0.091 0.649 0.334 0.846 0.863 0.781H157.813Z"
            />
            <path
                style={{
                    fill: '#ffb121',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M126.172 48.291c0.373 0.044 0.723 -0.26 1.172 -0.244v-0.781h-0.781c0.076 0.449 -0.157 0.7 -0.391 1.025Zm52.539 0.146c0.092 -0.368 -0.244 -0.724 -0.195 -1.172h-0.781c-0.047 0.723 0.604 0.844 0.977 1.172Z"
            />
            <path
                style={{
                    fill: '#ffad17',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M126.172 122.363c0.161 0.31 0.432 0.633 0.391 1.074h0.781v-0.781c-0.439 0.012 -0.795 -0.211 -1.172 -0.391v0.098ZM178.516 123.438c-0.053 -0.384 0.311 -0.871 0.195 -1.172 -0.266 0.255 -0.606 0.398 -0.977 0.391 -0.042 0.529 0.291 0.841 0.781 0.781Z"
            />
            <path
                style={{
                    fill: '#ffb938',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M115.234 111.328v-0.781h-0.781c-0.089 0.562 0.275 0.863 0.781 0.781Zm75.391 0v-0.781h-0.781c-0.089 0.562 0.275 0.863 0.781 0.781Z"
            />
            <path
                style={{
                    fill: '#ffbc41',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M115.234 60.156v-0.781h-0.781c-0.089 0.562 0.275 0.863 0.781 0.781Zm75.391 0v-0.781h-0.781c-0.089 0.562 0.275 0.863 0.781 0.781Z"
            />
            <path
                style={{
                    fill: '#d3deba',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M107.227 80.078c0.556 -0.42 0.661 -0.947 0.586 -1.563h-0.781c0.018 0.46 -0.083 1.113 0.195 1.563Zm90.625 0c0.282 -0.454 0.174 -1.099 0.195 -1.563h-0.781v0.781c0.134 0.286 0.332 0.561 0.586 0.781Z"
            />
            <path
                style={{
                    fill: '#d1dcb6',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M107.031 92.188h0.781c0.018 -0.543 -0.066 -1.375 -0.781 -1.563v1.563Zm90.234 0h0.781c0.001 -0.523 0.036 -1.08 -0.195 -1.563 -0.584 0.396 -0.648 0.947 -0.586 1.563Z"
            />
            <path
                style={{
                    fill: '#ffdb9a',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M107.227 79.688c0.164 -0.393 0.34 -1.097 -0.195 -1.172a3.17 3.17 0 0 0 0.195 1.172Zm90.625 0c0.164 -0.393 0.34 -1.097 -0.195 -1.172a3.17 3.17 0 0 0 0.195 1.172Z"
            />
            <path
                style={{
                    fill: '#ffda95',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M107.031 92.188a1.9 1.9 0 0 0 0.781 -0.195c-0.333 -0.316 -0.336 -0.918 -0.781 -0.977v1.172Zm90.234 -0.195c0.187 0.204 0.57 0.191 0.781 0.195 -0.004 -0.4 -0.093 -0.792 -0.195 -1.172 -0.043 0.469 -0.306 0.691 -0.586 0.977Z"
            />
            <path
                style={{
                    fill: '#ffc65f',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M109.766 101.685c0.13 0.277 0.566 0.135 0.781 0.073 -0.262 -0.079 -0.512 -0.159 -0.781 -0.195v0.122Zm84.766 0c0.13 0.277 0.566 0.135 0.781 0.073 -0.262 -0.079 -0.512 -0.159 -0.781 -0.195v0.122Z"
            />
            <path
                style={{
                    fill: '#ffcd72',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M107.031 91.919c0.13 0.277 0.566 0.135 0.781 0.073 -0.262 -0.079 -0.512 -0.159 -0.781 -0.195v0.122Zm90.234 0c0.13 0.277 0.566 0.135 0.781 0.073 -0.262 -0.079 -0.512 -0.159 -0.781 -0.195v0.122Z"
            />
            <path
                style={{
                    fill: '#ffc761',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M136.523 43.359c0.115 -0.251 0.189 -0.507 0.195 -0.781 -0.345 0.023 -0.416 0.302 -0.325 0.579l0.13 0.203Zm32.031 0c0.115 -0.251 0.189 -0.507 0.195 -0.781 -0.345 0.023 -0.416 0.302 -0.325 0.579l0.13 0.203Z"
            />
            <path
                style={{
                    fill: '#ffc966',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M109.766 68.872c0.13 0.277 0.566 0.135 0.781 0.073 -0.262 -0.079 -0.512 -0.159 -0.781 -0.195v0.122Zm84.766 0c0.13 0.277 0.566 0.135 0.781 0.073 -0.262 -0.079 -0.512 -0.159 -0.781 -0.195v0.122Z"
            />
            <path
                style={{
                    fill: '#ffc760',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M137.695 128.516c0.115 -0.251 0.189 -0.507 0.195 -0.781 -0.345 0.023 -0.416 0.302 -0.325 0.579l0.13 0.203Zm29.688 0c0.115 -0.251 0.189 -0.507 0.195 -0.781 -0.345 0.023 -0.416 0.302 -0.325 0.579l0.13 0.203Z"
            />
            <path
                style={{
                    fill: '#ffe6b9',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M147.266 234.107c0.13 0.277 0.566 0.135 0.781 0.073 -0.262 -0.079 -0.512 -0.158 -0.781 -0.195v0.122Zm9.766 0c0.13 0.277 0.566 0.135 0.781 0.073 -0.262 -0.079 -0.512 -0.158 -0.781 -0.195v0.122Z"
            />
            <path
                style={{
                    fill: '#ffefd2',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M147.656 234.155c0.134 0.16 0.246 0.117 0.391 0.024 -0.125 -0.079 -0.252 -0.168 -0.391 -0.025Zm9.375 0c0.134 0.16 0.246 0.117 0.391 0.024 -0.125 -0.079 -0.252 -0.168 -0.391 -0.025Z"
            />
        </svg>
    )
}
